import Vue from "vue";
import Router from "vue-router";
import Home from "@/views/home/Home.vue";
import Textual from "@/views/textual/Textual.vue";
import Contact from "@/views/contact/Contact.vue";
import Prize from "@/views/prize/Prize.vue";
import Register from "@/views/register/Register.vue";
import Points from "@/views/points/Points.vue";
import Redeemption from "@/views/redeemption/Redeemption.vue";
import Gift from "@/views/gifts/Gift.vue";
import Code from "@/views/code/Code.vue";
import Voucher from "@/views/voucher/Voucher.vue";
import VoucherGift from "@/views/voucherGift/VoucherGift.vue";
import Invite from "@/views/invite/Invite.vue";
import Redirect from '@/views/redirects/Redirect';
import Direct from '@/views/directLogin/Direct';
import AllPrizes from '@/views/allPrizes/AllPrizes.vue';
import Login from '@/views/login/Login.vue';

Vue.use(Router);

const config = require('../config.json')

export default new Router({
    scrollBehavior(to, from, savedPosition) {
        if (to.path != '/') {
            return { x: 0, y: 0 };
        }
    },
    mode: "history",
    base: config.baseUrl,
    routes: [{
            path: "",
            name: "home",
            component: Home
        },
        {
            path: "/contato",
            name: "contact",
            component: Contact
        },
        {
            path: "/premio/:id",
            name: "prize",
            component: Prize
        },
        {
            path: "/cadastro",
            name: "register",
            component: Register
        },
        {
            path: "/login",
            name: "login",
            component: Login
        },
        {
            path: "/meus-dados",
            name: "meusdados",
            component: Register
        },
        {
            path: "/meus-pontos",
            name: "points",
            component: Points
        },
        {
            path: "/meus-resgates",
            name: "redeemption",
            component: Redeemption
        },
        {
            path: "/meus-presentes",
            name: "gift",
            component: Gift
        },
        {
            path: "/codigo-pontuavel",
            name: "code",
            component: Code
        },
        {
            path: "/voucher/:id",
            name: "voucher",
            component: Voucher
        },
        {
            path: "/voucherPresente/:id",
            name: "voucherGift",
            component: VoucherGift
        },
        {
            path: "/indique",
            name: "invite",
            component: Invite
        },
        {
            path: "/beneficios",
            name: "AllPrizes",
            component: AllPrizes
        },
        {
            path: "/usrad/:data",
            name: "redirect",
            component: Redirect
        },
        {
            path: "/usrtk/:data",
            name: "Direct",
            component: Direct
        },
        {
            path: "/usrtk/:data/:opt",
            name: "Direct opt",
            component: Direct
        },
        {
            path: "/:data",
            name: "textual",
            component: Textual
        },
        
    ]
});